
// app/i18n/routing.ts
import config from '@/api/global';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // locales: ['en', 'fa'] as const,
  // defaultLocale: 'en',
  locales: config?.Langs?.map((d: any) => d.id), // e.g., ['en', 'fa']
  defaultLocale: config.defaultLocale, // e.g., 'en'
  localePrefix: 'as-needed',
});

export type Locale = (typeof routing.locales)[number]; // 'en' | 'fa'
